module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/header_images/header-b-db2c3dc511300e2233c5e8e1bb728067.svg";